export default "__VITE_ASSET__BV5vC4jE__"